import React from 'react';

import { BasicProperties } from './components';
import { useCovTablesQuery, useMpTablesQuery } from './queries';

interface Props {
  isEditMode: boolean;
  canBeLimited: boolean;
}

const BasicPropertiesContainer: React.FC<Props> = ({ isEditMode, canBeLimited }) => {
  const { options: mpTableOptions } = useMpTablesQuery();
  const { options: covTableOptions } = useCovTablesQuery();

  return (
    <BasicProperties
      isEditMode={isEditMode}
      canBeLimited={canBeLimited}
      mpTableOptions={mpTableOptions}
      covTableOptions={covTableOptions}
    />
  );
};

export default BasicPropertiesContainer;
